import * as THREE from 'three'

function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
    const words = text.split(' ')
    let line = ''

    for (const word of words) {
        const testLine = `${line}${word} `

        if (ctx.measureText(testLine).width > maxWidth && line) {
            ctx.fillText(line.trim(), x, y)
            line = `${word} `
            y += lineHeight
        }
        else {
            line = testLine
        }
    }

    if (line.trim()) {
        ctx.fillText(line.trim(), x, y)
        y += lineHeight
    }

    return y
}

export function createFloorTexture({
    title,
    subtitle = '',
    description = '',
    meta = [],
}) {
    const canvas = document.createElement('canvas')
    canvas.width = 2048
    canvas.height = 1024
    const ctx = canvas.getContext('2d')

    ctx.clearRect(0, 0, canvas.width, canvas.height)
    ctx.fillStyle = '#ffffff'
    ctx.textBaseline = 'top'

    const titleFontSize = title.length > 24 ? 82 : 118
    ctx.font = `700 ${titleFontSize}px "Comic Neue", Arial, sans-serif`
    let titleY = 90
    titleY = wrapText(ctx, title.toUpperCase(), 90, titleY, 920, titleFontSize + 8) + 12

    if (subtitle) {
        ctx.font = '700 52px "Comic Neue", Arial, sans-serif'
        ctx.fillText(subtitle.toUpperCase(), 95, titleY + 20)
        titleY += 72
    }

    ctx.font = '700 40px "Comic Neue", Arial, sans-serif'
    let descriptionY = subtitle ? titleY + 40 : titleY + 20
    descriptionY = wrapText(ctx, description, 95, descriptionY, 920, 52) + 20

    ctx.font = '700 44px "Comic Neue", Arial, sans-serif'
    let metaY = 120

    for (const item of meta) {
        if (!item.value) {
            continue
        }

        ctx.fillText(item.label.toUpperCase(), 1260, metaY)
        ctx.font = '700 36px "Comic Neue", Arial, sans-serif'
        metaY = wrapText(ctx, item.value, 1260, metaY + 52, 680, 46) + 28
        ctx.font = '700 44px "Comic Neue", Arial, sans-serif'
    }

    const texture = new THREE.CanvasTexture(canvas)
    texture.magFilter = THREE.NearestFilter
    texture.minFilter = THREE.LinearFilter
    texture.needsUpdate = true

    return texture
}

export function createSignTexture(label, { wooden = false, direction = false } = {}) {
    const canvas = document.createElement('canvas')
    canvas.width = 1024
    canvas.height = 256
    const ctx = canvas.getContext('2d')

    ctx.clearRect(0, 0, canvas.width, canvas.height)

    if(wooden)
    {
        ctx.fillStyle = '#c9a66b'
        ctx.beginPath()
        ctx.moveTo(40, 40)
        ctx.lineTo(920, 40)
        ctx.lineTo(984, 128)
        ctx.lineTo(920, 216)
        ctx.lineTo(40, 216)
        ctx.closePath()
        ctx.fill()

        ctx.strokeStyle = '#8e7161'
        ctx.lineWidth = 10
        ctx.stroke()

        ctx.fillStyle = '#4a3728'
    }
    else if(direction)
    {
        ctx.fillStyle = '#ffffff'
    }
    else
    {
        ctx.fillStyle = '#ffffff'
    }

    ctx.textBaseline = 'middle'
    ctx.textAlign = 'center'
    const fontSize = label.length > 12 ? 72 : 96
    ctx.font = `700 ${fontSize}px "Comic Neue", Arial, sans-serif`
    ctx.fillText(label.toUpperCase(), canvas.width / 2, canvas.height / 2)

    const texture = new THREE.CanvasTexture(canvas)
    texture.magFilter = THREE.NearestFilter
    texture.minFilter = THREE.LinearFilter
    texture.needsUpdate = true

    return texture
}
